import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML } from "@utils/CommonUtils";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { Button, Pagination, TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, DataTable } from "~/Components";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { useNotification } from "~/Hooks/useNotification";
import ActionDropdown, { TypeData } from "~/Modules/ECMS/PASSENGER/ActionDropdown";
import { magpCMSApi, post, remove } from "~/Services";
import { magpHost } from "~/Utils";
import {
  renderActionsColumn,
  renderDateColumn,
  renderPublishedColumn,
  renderUpdatedAtColumn,
} from "~/Utils/TableRenderFunction";

export const FAQ = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteConfirmLoading, setDeleteConfirmLoading] = useState(false);

  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [data, setData] = useState<any>([]);
  const [sortedData, setSortedData] = useState<any>([]);
  const currentPageData = sortedData.slice(currentPage * 10, (currentPage + 1) * 10);
  const [sortOrder, setSortOrder] = useState<string | undefined>();
  const [orderByName, setOrderByName] = useState<string>("id");
  const [selectedPublishedType, setselectedPublishedType] = useState<any>("");
  console.log("selectedPublishedType", selectedPublishedType);
  const publishedType: TypeData[] = [
    {
      label: "Published",
      value: true,
    },
    {
      label: "Unpublished",
      value: false,
    },
  ];

  const [reviewNotes, setReviewNotes] = useState("");
  const [reviewNotesError, setReviewNotesError] = useState(false);

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useFAQDocumentDetails(id || "");

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  useEffect(() => {
    let filteredData = data;

    if (searchValue) {
      filteredData = filteredData.filter((item: any) => {
        return (
          item.field_order_sequence.toString().includes(searchValue.toLowerCase()) ||
          // item.field_faqs_header.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.field_faqs_question.toLowerCase().includes(searchValue.toLowerCase())
          // item.updated_at.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    }
    if (selectedPublishedType !== undefined && selectedPublishedType !== "") {
      filteredData = filteredData.filter((item: any) => item.field_faq_published === selectedPublishedType);
    }
    setSortedData(filteredData);
    setTotalRecords(filteredData.length);
    setCurrentPage(0);
  }, [data, searchValue, selectedPublishedType]);

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/faqs/all-fields`;
    magpCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setTotalRecords(envelopes.length);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  const handleDelete = async (id: string) => {
    remove(`${magpHost}/api/faq-details/${id}`)
      .then((res) => {
        getRecords();
      })
      .catch((err) => {});
  };

  const columns: TableColumnsType = [
    {
      title: "FAQ Order Sequence",
      dataIndex: "field_order_sequence",
      key: "field_order_sequence",
      sorter: true,
      width: 60,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_order_sequence"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_order_sequence"
            ? "descend"
            : undefined,
    },
    {
      title: "FAQ Questions",
      dataIndex: "field_faqs_question",
      key: "field_faqs_question",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_faqs_question"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_faqs_question"
            ? "descend"
            : undefined,
      render: (text) => decodeHTML(text),
    },
    {
      title: "Published",
      dataIndex: "field_faq_published",
      key: "field_faq_published",
      width: 50,
      render: renderPublishedColumn,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 50,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "created_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "created_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Created By",
      dataIndex: "field_faq_created_by",
      key: "field_faq_created_by",
      width: 50,
      fixed: "right",
      render: (text: string) => renderUpdatedAtColumn(text),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 50,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updated_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updated_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Updated By",
      dataIndex: "field_faq_updated_by",
      key: "field_faq_updated_by",
      width: 50,
      fixed: "right",
    },
    {
      title: "Actions",
      key: "actions",
      width: 50,
      fixed: "right",
      render: (record: any) =>
        renderActionsColumn(
          record,
          setSelectedRowData,
          setDrawerVisible,
          (e: any) => {
            e.preventDefault();
            navigate(`/dedicated/magp/faq/add?editId=${record.id}`);
          },
          undefined,
          setDeleteModalVisible,
          "faq"
        ),
    },
  ];

  useEffect(() => {
    getRecords();
  }, []);

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";

    if (sortOrder === "asc") {
      setSortOrder("desc");
      order = "desc";
    } else if (sortOrder === "desc") {
      setSortOrder(undefined);
      order = undefined;
    } else if (sortOrder === undefined) {
      setSortOrder("asc");
      order = "asc";
    }

    setOrderByName(column.dataIndex);

    const tempData = [...data];
    setSortedData(tempData.sort((a: any, b: any) => handleSort(a, b, order, column.dataIndex)));
    setCurrentPage(0);
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }

    const payload = {
      action: action,
      method: method,
      module: "FAQ",
      subModule: "faq",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteFAQRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${magpHost}/api/faq-details/${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  return (
    <ContentWrapper
      title={"FAQs"}
      actionItems={
        <Button
          onClick={() => {
            navigate("/dedicated/magp/faq/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New FAQ
        </Button>
      }
    >
      <>
        <DataTable
          columns={columns.map((col) => ({
            ...col,
            onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
          }))}
          multiSelect={false}
          className="table-clickable"
          tableData={
            currentPageData
              ? currentPageData?.map((d: any) => {
                  return {
                    ...d,
                  };
                })
              : []
          }
          isLoading={isLoading}
          exportFileName="CONTRACT"
          isPagination={true}
          recordsPerPage={10}
          onSearchChange={(searchText: string) => {
            setSearchValue(searchText);
            setCurrentPage(0);
          }}
          hideExport={true}
          isServerSearchApi={false}
          searchPlaceholderText={"Search"}
          onClick={(record) => {
            setSelectedRowData(record);
          }}
          additionalCTA={
            <div className="flex items-center space-x-2">
              <ActionDropdown
                value={selectedPublishedType}
                options={publishedType}
                onChange={setselectedPublishedType}
                placeholder="Select Published"
              />
            </div>
          }
        />
        <div className="pagination">
          <Pagination
            defaultCurrent={1}
            current={currentPage + 1}
            total={totalRecords}
            onChange={(curPage) => {
              setCurrentPage(curPage - 1);
            }}
            showSizeChanger={false}
          />
        </div>

        <TableDrawer
          title={
            <Typography.Title
              level={4}
              className={"!mb-0"}
            >
              Detailed View
            </Typography.Title>
          }
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          fields={drilldownData[_get(drilldown, "subModule", "faq") as ModuleConfig]}
          data={drilldown}
        />

        <ConfirmationModal
          type="delete"
          open={deleteModalVisible}
          onClose={() => setDeleteModalVisible(false)}
          onSubmit={sendDeleteFAQRequest}
        />
      </>
    </ContentWrapper>
  );
};

function handleSort(a: any, b: any, order: string, sortBy: string) {
  if (sortBy === "field_faqs_question") {
    const numberA = extractNumber(a[sortBy]);
    const numberB = extractNumber(b[sortBy]);

    if (order === "desc") {
      return numberA < numberB ? 1 : -1;
    } else if (order === "asc") {
      return numberA > numberB ? 1 : -1;
    } else {
      return 0;
    }
  }

  if (order === "desc") {
    return a[sortBy] < b[sortBy] ? 1 : -1;
  } else if (order === "asc") {
    return a[sortBy] > b[sortBy] ? 1 : -1;
  } else {
    return 0;
  }
}

function extractNumber(question: string): number {
  const match = question.match(/Q(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}
